import { Button, Flex, Group } from '@mantine/core';

import FiltersMultiSelect from '../../../common/filtersMultiSelect/FiltersMultiSelect';
import { IconPlus } from '@tabler/icons-react';

const GroupToolbarActions = ({
    filterOptions,
    onFilterChanged,
    openCreateModal,
}) => {
    return (
        <>
            <Group
                ms={'xs'}
                gap={'xs'}
                align='flex-start'
                w={'100%'}>
                <FiltersMultiSelect
                    options={filterOptions}
                    onChange={onFilterChanged}
                />
            </Group>
            <Flex
                px={'md'}
                w={'100%'}
                align={'bottom'}
                justify={'flex-end'}>
                <Button
                    size={'compact-xs'}
                    leftSection={
                        <IconPlus
                            style={{ width: '70%', height: '70%' }}
                            stroke={1.5}
                        />
                    }
                    styles={{
                        section: {
                            marginInlineEnd: 0,
                        },
                    }}
                    onClick={openCreateModal}>
                    New Group
                </Button>
            </Flex>
        </>
    );
};
export default GroupToolbarActions;
